import { get } from "lodash";
import { container, ENV_KEY } from "../container";
var Query = /** @class */ (function () {
    function Query(path, subPath) {
        var _this = this;
        Object.defineProperty(this, "aggregator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "path", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "subPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "get", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var _a;
                var widget = (_a = _this.aggregator) === null || _a === void 0 ? void 0 : _a.getWidget(_this.path);
                if (widget && _this.subPath) {
                    return get(widget, _this.subPath);
                }
                return widget;
            }
        });
        Object.defineProperty(this, "getProperty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (key) {
                var entity = _this.get();
                if (entity) {
                    return get(entity, key);
                }
            }
        });
        Object.defineProperty(this, "getFormOrProp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var _a;
                var form = (_a = _this.aggregator) === null || _a === void 0 ? void 0 : _a.getForm(_this.path);
                if (form && _this.subPath) {
                    return get(form, _this.subPath);
                }
                return form;
            }
        });
        Object.defineProperty(this, "getChildren", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var _a;
                var widgets = (_a = _this.aggregator) === null || _a === void 0 ? void 0 : _a.matchWidgets(_this.path).filter(function (item) { return item.path !== _this.path; });
                return widgets || [];
            }
        });
        this.path = path;
        this.subPath = subPath === null || subPath === void 0 ? void 0 : subPath.replace("/", ".");
        var env = container.resolve(ENV_KEY);
        this.aggregator = env === null || env === void 0 ? void 0 : env.app.aggregator;
    }
    return Query;
}());
export { Query };
